import React, { useEffect, useState } from 'react';
import { pageTitle } from '../PageTitle';
import HeaderOne from '../Header/HeaderTwo';
import FooterOne from '../Footer/FooterTwo';
import BreadCrumb from '../BreadCrumb';
import { Link } from 'react-router-dom';
import { fetchSoftwares } from '../../DataFetchers/fetchSoftwares';


const Softwares = () => {
    pageTitle('Software Portfolio');

    const [softwaresData, setSoftwaresData] = useState([]);
    
    useEffect(() => {
        fetchSoftwares().then((data) => {
            setSoftwaresData(data);
        });
    }, []);

    return (

        <>
            <HeaderOne></HeaderOne>
            <BreadCrumb title={"Software Portfolio"}></BreadCrumb>
            <div className="blog__page p_relative see__pad">
                <div className="auto-container">
                    <div className="row">
                        {softwaresData.map((item, id) => (
                            <div className="col-lg-4 col-md-6 col-sm-12 news__block" key={id}>
                                <div className="news___block wow slideInUp animated animated" data-wow-delay={item.data_aos_delay} data-wow-duration="1500ms">
                                    <div className="inner-box p_relative">
                                        <div className="image-box p_relative d_block">
                                            <figure className="image p_relative d_block">
                                                <Link to={`/software-details?software=${encodeURIComponent(item.title)}`} state={{ item }}><img src={item.image} alt="" /></Link>
                                            </figure>
                                        </div>
                                        <div className="lower___content p_relative">
                                            <h6 style={{ color: "yellow", opacity: item.status === 'Commercial' ? 1 : 0.5, padding: "0px", margin:"0px" }}>{item.status}</h6>
                                            <h4 style={{ paddingBottom: '0px' }}><Link to={`/software-details?software=${encodeURIComponent(item.title)}`} state={{ item }}>{item.title}</Link></h4>

                                            <div className="btn__box__two">
                                                <Link to={`/software-details?software=${encodeURIComponent(item.title)}`} state={{ item }} className="theme__btn__two"><i className="icon-02"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <FooterOne></FooterOne>
        </>
    );
};

export default Softwares;
